/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ teams: NonNullable<unknown> }} Bracket_FormatInputs */

const th_bracket_format = /** @type {(inputs: Bracket_FormatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`รูปแบบ · แพ้คัดออก · ${i?.teams} ทีม`)
};

const en_bracket_format = /** @type {(inputs: Bracket_FormatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Format · single-elimination · ${i?.teams} teams`)
};

const ja_bracket_format = /** @type {(inputs: Bracket_FormatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`方式 · シングルエリミネーション · ${i?.teams}チーム`)
};

const zh_bracket_format = /** @type {(inputs: Bracket_FormatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`赛制 · 淘汰赛 · ${i?.teams} 支球队`)
};

const es_bracket_format = /** @type {(inputs: Bracket_FormatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Formato · eliminación directa · ${i?.teams} equipos`)
};

const pt_bracket_format = /** @type {(inputs: Bracket_FormatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Formato · mata-mata · ${i?.teams} times`)
};

const id_bracket_format = /** @type {(inputs: Bracket_FormatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Format · Sistem gugur · ${i?.teams} tim`)
};

const fr_bracket_format = /** @type {(inputs: Bracket_FormatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Format · élimination directe · ${i?.teams} équipes`)
};

const tl_bracket_format = /** @type {(inputs: Bracket_FormatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pormat · Knockout · ${i?.teams} team`)
};

const vi_bracket_format = /** @type {(inputs: Bracket_FormatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Thể thức · Loại trực tiếp · ${i?.teams} đội`)
};

const ko_bracket_format = /** @type {(inputs: Bracket_FormatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`방식 · 토너먼트 · ${i?.teams}팀`)
};

const de_bracket_format = /** @type {(inputs: Bracket_FormatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Format · K.-o.-System · ${i?.teams} Teams`)
};

const ru_bracket_format = /** @type {(inputs: Bracket_FormatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Формат · На вылет · ${i?.teams} команд`)
};

const tr_bracket_format = /** @type {(inputs: Bracket_FormatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Format · Eleme · ${i?.teams} takım`)
};

const it_bracket_format = /** @type {(inputs: Bracket_FormatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Formato · Eliminazione diretta · ${i?.teams} squadre`)
};

const pl_bracket_format = /** @type {(inputs: Bracket_FormatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Format · Pucharowy · ${i?.teams} drużyn`)
};

const uk_bracket_format = /** @type {(inputs: Bracket_FormatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Формат · На вибування · ${i?.teams} команд`)
};

const hi_bracket_format = /** @type {(inputs: Bracket_FormatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`प्रारूप · नॉकआउट · ${i?.teams} टीमें`)
};

const ar_bracket_format = /** @type {(inputs: Bracket_FormatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`النظام · خروج المغلوب · ${i?.teams} فريقًا`)
};

const ms_bracket_format = /** @type {(inputs: Bracket_FormatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Format · Kalah mati · ${i?.teams} pasukan`)
};

const bn_bracket_format = /** @type {(inputs: Bracket_FormatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ধরন · নকআউট · ${i?.teams}টি দল`)
};

const zh_tw2_bracket_format = /** @type {(inputs: Bracket_FormatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`賽制 · 淘汰賽 · ${i?.teams} 支球隊`)
};

const zh_hk2_bracket_format = /** @type {(inputs: Bracket_FormatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`賽制 · 淘汰賽 · ${i?.teams} 支球隊`)
};

const ur_bracket_format = /** @type {(inputs: Bracket_FormatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`طریقہ · ناک آؤٹ · ${i?.teams} ٹیمیں`)
};

const fa_bracket_format = /** @type {(inputs: Bracket_FormatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`قالب · حذفی · ${i?.teams} تیم`)
};

const sw_bracket_format = /** @type {(inputs: Bracket_FormatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Muundo · Mtoano · timu ${i?.teams}`)
};

const nl_bracket_format = /** @type {(inputs: Bracket_FormatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Opzet · Knock-out · ${i?.teams} teams`)
};

/**
* | output |
* | --- |
* | "Format · single-elimination · {teams} teams" |
*
* @param {Bracket_FormatInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const bracket_format = /** @type {((inputs: Bracket_FormatInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bracket_FormatInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_bracket_format(inputs)
	if (locale === "ja") return ja_bracket_format(inputs)
	if (locale === "zh") return zh_bracket_format(inputs)
	if (locale === "es") return es_bracket_format(inputs)
	if (locale === "pt") return pt_bracket_format(inputs)
	if (locale === "id") return id_bracket_format(inputs)
	if (locale === "fr") return fr_bracket_format(inputs)
	if (locale === "tl") return tl_bracket_format(inputs)
	if (locale === "vi") return vi_bracket_format(inputs)
	if (locale === "ko") return ko_bracket_format(inputs)
	if (locale === "de") return de_bracket_format(inputs)
	if (locale === "ru") return ru_bracket_format(inputs)
	if (locale === "tr") return tr_bracket_format(inputs)
	if (locale === "it") return it_bracket_format(inputs)
	if (locale === "pl") return pl_bracket_format(inputs)
	if (locale === "uk") return uk_bracket_format(inputs)
	if (locale === "hi") return hi_bracket_format(inputs)
	if (locale === "ar") return ar_bracket_format(inputs)
	if (locale === "ms") return ms_bracket_format(inputs)
	if (locale === "bn") return bn_bracket_format(inputs)
	if (locale === "zh-TW") return zh_tw2_bracket_format(inputs)
	if (locale === "zh-HK") return zh_hk2_bracket_format(inputs)
	if (locale === "ur") return ur_bracket_format(inputs)
	if (locale === "fa") return fa_bracket_format(inputs)
	if (locale === "sw") return sw_bracket_format(inputs)
	if (locale === "nl") return nl_bracket_format(inputs)
	return en_bracket_format(inputs)
});